"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    PY3013: 'PY3013',
    PY3009: 'PY3009',
    BK5000: 'BK5000',
    PY3001: 'PY3001', // Page not found
};
